import { connect } from 'react-redux'
import { MessageThreadPage } from './MessageThread'
import showFlowCreateModal from 'features/Flows/FlowCreateModal'
import { showThreadCreateModal } from 'features/Messages/ThreadCreateModal'
import { showContactCreateModal } from 'features/Contacts/ContactCreateModal'

const stateToProps = () => {
  return {}
}

export const dispatchToProps = {
  showFlowCreateModal,
  showThreadCreateModal,
  showContactCreateModal,
}

export const MessageThreadPageContainer = connect(stateToProps, dispatchToProps)(MessageThreadPage)



// WEBPACK FOOTER //
// src/pages/MessageThread/MessageThread.container.ts